import './alert.scss'
import {Snackbar,Alert,AlertColor} from '@mui/material'


interface iProps {open:boolean,setOpen:Function,message:string,type:AlertColor}

const  MyAlert =({open,setOpen,message,type}:iProps)=>{
    const handleClose=()=>{
        setOpen()
    }
        return (

                <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}
                anchorOrigin={{vertical:'top',horizontal:'center'}}
                >
                    <Alert onClose={handleClose} severity={type} sx={{ width: '100%' }}>
                    {message}
                    </Alert>
                </Snackbar>
        )
}
export default MyAlert;